export default function RegularButton({
  children,
  handleClick,
  type = 'submit',
  variant = 'text',
}) {
  const variantClass = variant === 'cta' ? 'btn--cta' : 'btn--text'
  return (
    <button className={`btn ${variantClass}`} type={type} onClick={handleClick}>
      {children}
    </button>
  )
}
